import { useTexts } from 'utils/useTexts';
import Footer from '@components/shared/Footer/Footer';
import TwoYearsAddressHistoryForm from '@components/TwoYearsAddressHistoryForm/TwoYearsAddressHistoryForm';

const TwoYearsAddressHistory = () => {
  const { t } = useTexts();

  return (
    <>
      <TwoYearsAddressHistoryForm />

      <Footer text={t('enterLicensePlate.footer.footerText')} />
    </>
  );
};

export default TwoYearsAddressHistory;
